import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { SET_CART_DATA_OBJECT } from "../store/slice/model/Cart";
import Toast from "../component/Toast";
import { ModalChaining } from "../component/Global/Modal";
import HCLDX from "@system/config/hcldx";
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const NotDeployedToHcldx = React.lazy(() => import("../layout/default/not-deployed-to-hcldx"));
const DeployedToHcldx = React.lazy(() => import("../layout/default/deployed-to-hcldx"));
const DeployedToEverywhere = React.lazy(() => import("../layout/default/deployed-to-everywhere"));
const Theme2Activator = React.lazy(() => import("../layout/default/theme2-activator"));

function DOMAttachToSystem() {
    const dispatch = useDispatch()
    const [DeployedToEverywhereLoaded, SetDeployedToEverywhereLoaded] = useState(false)
    const [{ latest_event_fired, latest_event_fired_uuid, eventFired }, { }, { }] = useDOMAttachToSystemStore();
    const [{ CART_DATA }, { }, { }] = useCartStore();

    // Confirm
    useEffect(() => {
        if (eventFired !== undefined &&
            latest_event_fired &&
            eventFired[latest_event_fired] !== undefined) {
        }
    }, [latest_event_fired_uuid]);

    useEffect(() => {
        dispatch(SET_CART_DATA_OBJECT());
    }, [CART_DATA]);

    return (
        <>
            <DeployedToEverywhere SetDeployedToEverywhereLoaded={() => {
                SetDeployedToEverywhereLoaded(true)
            }} />
            {process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes' &&
                <NotDeployedToHcldx />
            }
            {DeployedToEverywhereLoaded && window.avnet !== undefined &&
                System.getCurrentSiteSpeedboat() === 'ebv' &&
                <Theme2Activator />
            }
            {HCLDX.get_REACT_APP_HCL_DX_BASE_URL() &&
                <DeployedToHcldx />
            }
            <ModalChaining />
            <Toast />
        </>
    );
}

export default DOMAttachToSystem;
